import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { PlannedMaintenanceDto } from "../../../../shared/models/maintenance/planned-maintenance.dto";
import { PlannedMaintenanceServiceDto } from "../../../../shared/models/maintenance/planned-maintenance-service.dto";
import { PlannedMaintenancesService } from "../../../../shared/services/planned-maintenances.service";
import { ServicesHierarchicalSelectorComponent } from "../../../../shared/components/services-hierarchical-selector/services-hierarchical-selector.component";
import { DialogService } from "@progress/kendo-angular-dialog";
import { NewRequestService } from "../../../../shared/models/request/new-request/new-request-service";

@Component({
    selector: 'agreement-maintenance-services',
    templateUrl: './agreement-maintenance-services.component.html',
    styleUrls: [
        './agreement-maintenance-services.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class AgreementMaintenanceServicesComponent implements OnChanges {
    
    @Input() maintenance: PlannedMaintenanceDto;
    @Input() discount: number;
    @Input() isReadonly: boolean = false;

    @Output() deleteMaintenanceEvent: EventEmitter<PlannedMaintenanceDto> = new EventEmitter<PlannedMaintenanceDto>();
    @Output() updateMaintenanceEvent: EventEmitter<PlannedMaintenanceDto> = new EventEmitter<PlannedMaintenanceDto>();

    groupedServices: PlannedMaintenanceServiceDto[] = [];

    loading: boolean;

    constructor (
        private plannedMaintenancesService: PlannedMaintenancesService,
        private dialogService: DialogService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.groupServices(this.maintenance.plannedMaintenanceServices);
    }

    groupServices(services: PlannedMaintenanceServiceDto[]) {
        this.groupedServices = [];
        services.forEach(service => {
            let groupedService = this.groupedServices.find(x => x.serviceId == service.serviceId);
            if (groupedService == null) {
                service.count = 1;
                this.groupedServices.push(service);
            }
            else {
                groupedService.count++;
            }
        });
    }

    getSumWithDiscount(service: PlannedMaintenanceServiceDto) {
        let fullSum = service.count != null ? service.count * service.cost : 0;
        return fullSum - (fullSum / 100 * this.discount);
    }

    deleteMaintenance() {
        this.deleteMaintenanceEvent.emit(this.maintenance);
    }

    addNewService() {
        const dialogRef = this.dialogService.open({ 
            content: ServicesHierarchicalSelectorComponent, 
            title: 'Добавление услуг',
            width: '80%',
            height: '820px',
            minWidth: '800px'
        });
        const serviceSelector = <ServicesHierarchicalSelectorComponent>dialogRef.content.instance;

        let existingServices = this.maintenance.plannedMaintenanceServices.map(x => {
            let requestService = new NewRequestService;
            requestService.serviceId = x.serviceId;
            return requestService;
        });

        serviceSelector.height = 460;
        serviceSelector.existingServices = existingServices;
        console.log(existingServices);
        serviceSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        serviceSelector.onContinue.subscribe((services: NewRequestService[]) => {
            dialogRef.close();
            this.loading = true;

            services.forEach(service => {
                let newPlannedService = new PlannedMaintenanceServiceDto;
                newPlannedService.agreementId = this.maintenance.agreementId;
                newPlannedService.cost = service.cost;
                newPlannedService.discount = service.discount;
                newPlannedService.serviceId = service.serviceId;
                newPlannedService.plannedMaintenanceId = this.maintenance.plannedMaintenanceId;

                for (let i = 0; i < service.count; i++) {
                    this.maintenance.plannedMaintenanceServices.push(newPlannedService);
                }
            });

            this.updateMaintenanceEvent.emit(this.maintenance);
            this.loading = false;
        });
    }

    removeServiceHandler({ dataItem }) {
        this.maintenance.plannedMaintenanceServices = this.maintenance.plannedMaintenanceServices.filter(x => 
            x.serviceId != dataItem.serviceId);
        this.updateMaintenanceEvent.emit(this.maintenance);
    } 

    get hasServices(): boolean {
        return this.maintenance != null && this.maintenance.plannedMaintenanceServices.length > 0;
    }
}